import dayjs, { Dayjs } from "dayjs";
import { DateRange } from "@/domains/common";
// components
import { Radio, RadioChangeEvent } from "antd";

export type DateRangeRadioGroupChangeEvent = (
  dateRange: DateRange,
  getDateRange?: () => Dayjs[]
) => void;

export interface DateRangeRadioGroupProps {
  dateRange: DateRange;
  onChange: DateRangeRadioGroupChangeEvent;
}

export const DateRangeRadioGroup = ({
  dateRange,
  onChange,
}: DateRangeRadioGroupProps) => {
  const dateRangeButtons = [
    {
      label: "今天",
      value: DateRange.day0,
      getDateRange: () => [dayjs().startOf("day"), dayjs().endOf("day")],
    },
    {
      label: "昨天",
      value: DateRange.day1,
      getDateRange: () => [
        dayjs().subtract(1, "day").startOf("day"),
        dayjs().subtract(1, "day").endOf("day"),
      ],
    },
    {
      label: "本周",
      value: DateRange.week0,
      getDateRange: () => [dayjs().startOf("week"), dayjs().endOf("week")],
    },
    {
      label: "上周",
      value: DateRange.week1,
      getDateRange: () => [
        dayjs().subtract(1, "week").startOf("week"),
        dayjs().subtract(1, "week").endOf("week"),
      ],
    },
    {
      label: "本月",
      value: DateRange.month0,
      getDateRange: () => [dayjs().startOf("month"), dayjs().endOf("month")],
    },
    {
      label: "上月",
      value: DateRange.month1,
      getDateRange: () => [
        dayjs().subtract(1, "month").startOf("month"),
        dayjs().subtract(1, "month").endOf("month"),
      ],
    },
    {
      label: "自訂",
      value: DateRange.custom,
    },
  ];

  const handleDateChange = (e: RadioChangeEvent) => {
    const button = dateRangeButtons.find((b) => b.value === e.target.value)!;
    onChange(button.value, button.getDateRange);
  };

  return (
    <Radio.Group value={dateRange} onChange={(e) => handleDateChange(e)}>
      {dateRangeButtons.map((button) => (
        <Radio.Button value={button.value} key={button.value}>
          {button.label}
        </Radio.Button>
      ))}
    </Radio.Group>
  );
};
